// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".assets-scss-gridstyleGrid-container-caxtd{margin:0 auto;max-width:1536px;padding:0 12px;width:100%}.assets-scss-gridstyleGrid-grid-bzzfj{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.assets-scss-gridstyleGrid-col6-obdcv{grid-column:span 6}.assets-scss-gridstyleGrid-col3-plorw{grid-column:span 3}.assets-scss-gridstyleGrid-col4-cbtio{grid-column:span 4}.assets-scss-gridstyleGrid-col9-ejdem{grid-column:span 9}.assets-scss-gridstyleGrid-col12-xadxx{grid-column:span 12}.assets-scss-gridstyleGrid-alignItemsStart-carjy{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "assets-scss-gridstyleGrid-container-caxtd",
	"grid": "assets-scss-gridstyleGrid-grid-bzzfj",
	"col6": "assets-scss-gridstyleGrid-col6-obdcv",
	"col3": "assets-scss-gridstyleGrid-col3-plorw",
	"col4": "assets-scss-gridstyleGrid-col4-cbtio",
	"col9": "assets-scss-gridstyleGrid-col9-ejdem",
	"col12": "assets-scss-gridstyleGrid-col12-xadxx",
	"alignItemsStart": "assets-scss-gridstyleGrid-alignItemsStart-carjy"
};
module.exports = ___CSS_LOADER_EXPORT___;
